export default __webpack_public_path__ + "static/media/chronograph-watch.d8463e94.svg";